import { createSelector } from 'reselect'
import { commentsApi, getFixedCacheKey } from './api'
import { RootState } from '../../reducers'
import { CommentId } from './types'
import { openBotIdSelector } from '../../store/app/selectors'

export const getCommentsQueryStateSelector = (state: RootState) =>
  commentsApi.endpoints.getComments.select({ botId: openBotIdSelector(state)! })(state)

export const updateCommentQueryStateSelectorMaker = (commentId: CommentId) => (state: RootState) =>
  commentsApi.endpoints.updateComment.select({
    fixedCacheKey: getFixedCacheKey.updateComment(commentId),
    requestId: `updateComment${commentId}`
  })(state)

export const submitCommentQueryStateSelectorMaker = (commentId: CommentId) => (state: RootState) =>
  commentsApi.endpoints.submitNewComment.select({
    fixedCacheKey: getFixedCacheKey.submitNewComment(commentId),
    requestId: `submitNewComment${commentId}`
  })(state)

export const isCommentSubmittingToServerSelectorMaker = (commentId: CommentId) =>
  createSelector(
    updateCommentQueryStateSelectorMaker(commentId),
    submitCommentQueryStateSelectorMaker(commentId),
    (updateCommentQueryState, submitCommentQueryState) => {
      return updateCommentQueryState.isLoading || submitCommentQueryState.isLoading
    }
  )

export const didCommentFailSubmittingToServerSelectorMaker = (commentId: CommentId) =>
  createSelector(
    updateCommentQueryStateSelectorMaker(commentId),
    submitCommentQueryStateSelectorMaker(commentId),
    (updateCommentQueryState, submitCommentQueryState) => {
      return updateCommentQueryState.isError || submitCommentQueryState.isError
    }
  )

export const serverCommentsByIdSelector = (state: RootState) =>
  getCommentsQueryStateSelector(state).data?.commentsById

export const serverAuthorsByIdSelector = (state: RootState) =>
  getCommentsQueryStateSelector(state).data?.authorsById

export const didCommentsFetchingFailSelector = createSelector(
  getCommentsQueryStateSelector,
  queryState => {
    const { isLoading, isError } = queryState
    return isError && !isLoading
  }
)
